import type { Group } from '@partou/my-group/data';
import { MOCK_LOCATIONS } from './mock-locations.const';

export const MOCK_GROUPS = {
  vlindertjes: { id: 'grp-1', name: 'De Vlindertjes', location: MOCK_LOCATIONS.kerkstraat },
  vlindertjesSingel: { id: 'grp-1b', name: 'De Vlindertjes', location: MOCK_LOCATIONS.singel },
  bijtjes: { id: 'grp-2', name: 'De Bijtjes', location: MOCK_LOCATIONS.kerkstraat },
  leeuwtjes: { id: 'grp-3', name: 'De Leeuwtjes', location: MOCK_LOCATIONS.singel },
  kikkertjes: { id: 'grp-4', name: 'De Kikkertjes', location: MOCK_LOCATIONS.singel },
  vogeltjes: { id: 'grp-5', name: 'De Vogeltjes', location: MOCK_LOCATIONS.prinsHendrikkade },
  olifantjes: { id: 'grp-6', name: 'De Olifantjes', location: MOCK_LOCATIONS.westerstraat },
  honden: { id: 'grp-7', name: 'De Honden', location: MOCK_LOCATIONS.keizersgracht },
  katjes: { id: 'grp-8', name: 'De Katjes', location: MOCK_LOCATIONS.vondelparkweg },
} as const satisfies Record<string, Group>;

const EXTRA_GROUPS: ReadonlyArray<Group> = [
  { id: 'grp-9', name: 'De Beertjes', location: MOCK_LOCATIONS.kerkstraat },
  { id: 'grp-10', name: 'De Puisjes', location: MOCK_LOCATIONS.singel },
  { id: 'grp-11', name: 'De Konijntjes', location: MOCK_LOCATIONS.prinsHendrikkade },
  { id: 'grp-12', name: 'De Eendjes', location: MOCK_LOCATIONS.westerstraat },
  { id: 'grp-13', name: 'De Visjes', location: MOCK_LOCATIONS.keizersgracht },
  { id: 'grp-14', name: 'De Sterretjes', location: MOCK_LOCATIONS.vondelparkweg },
  { id: 'grp-15', name: 'De Maantjes', location: MOCK_LOCATIONS.kerkstraat },
  { id: 'grp-16', name: 'De Zonnetjes', location: MOCK_LOCATIONS.singel },
  { id: 'grp-17', name: 'De Wolkjes', location: MOCK_LOCATIONS.prinsHendrikkade },
  { id: 'grp-18', name: 'De Bloemetjes', location: MOCK_LOCATIONS.westerstraat },
  { id: 'grp-19', name: 'De Kabouters', location: MOCK_LOCATIONS.keizersgracht },
  { id: 'grp-20', name: 'De Reuzen', location: MOCK_LOCATIONS.vondelparkweg },
  { id: 'grp-21', name: 'De Dwergen', location: MOCK_LOCATIONS.kerkstraat },
  { id: 'grp-22', name: 'De Krekels', location: MOCK_LOCATIONS.singel },
  { id: 'grp-23', name: 'De Mieren', location: MOCK_LOCATIONS.prinsHendrikkade },
  { id: 'grp-24', name: 'De Rupsjes', location: MOCK_LOCATIONS.westerstraat },
  { id: 'grp-25', name: 'De Pinguïns', location: MOCK_LOCATIONS.keizersgracht },
  { id: 'grp-26', name: 'De Zeehondjes', location: MOCK_LOCATIONS.vondelparkweg },
  { id: 'grp-27', name: 'De Dolfijntjes', location: MOCK_LOCATIONS.kerkstraat },
  { id: 'grp-28', name: 'De Walvisjes', location: MOCK_LOCATIONS.singel },
];

export const MOCK_GROUPS_LIST: ReadonlyArray<Group> = [...Object.values(MOCK_GROUPS), ...EXTRA_GROUPS];
